// This icon file is generated automatically.
var LeftFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M16 6a1 1 0 00-1.64-.77l-6 5a1 1 0 000 1.54l6 5A1 1 0 0016 16V6z" } }] }, "name": "left", "theme": "filled" };
export default LeftFilled;
